export default __webpack_public_path__ + "static/img-ef-5-5710efcbc54581442eb8d5ffe04ba11d.png";